import { BehaviorSubject, Observable, of } from 'rxjs';
import {
  LinkedCategory,
  PageableResponse,
  Product,
  SearchProduct
} from './interfaces';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ProductsService } from './products.service';
import { catchError, finalize } from 'rxjs/operators';

export class ProductDataSource implements DataSource<Product> {
  public data: Product[] | [];
  public relatedProducts: LinkedCategory[] | [];
  public totalCount: number;
  public search: SearchProduct;
  private isLoadingMore: boolean;

  private productsSubject = new BehaviorSubject<Product[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  constructor(private productsService: ProductsService) {
  }

  connect(collectionViewer: CollectionViewer): Observable<Product[]> {
    return this.productsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.productsSubject.next([]);
    this.loadingSubject.next(false);
  }

  loadProducts(
    search: SearchProduct,
    mergeResult = false,
    isRelatedProductsCall:boolean = false,
  ) {
    this.search = search;
    this.loadingSubject.next(true);
    this.productsService.getProducts(search,isRelatedProductsCall).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe(
      (response: { Paging: PageableResponse[], Topics: Product[] }) => {
        response.Topics = response?.Topics?.map(t => {
          t.AccessList = search.organziationId;
          return t;
        })
        this.isLoadingMore = false;
        this.totalCount = response?.Paging?.[0]?.TotalCount || 0;
        this.data =
          mergeResult ? [...this.data, ...response.Topics ?? []] : [...response.Topics ?? []];
        this.productsSubject.next(response.Topics ?? []);
      });
  }

  loadMore() {
    if (this.totalCount <= this.search.start + this.search.limit) {
      return;
    }
    if (!this.isLoadingMore) {
      this.isLoadingMore = true;
      this.search.start += this.search.limit;
      this.loadProducts(this.search, true);
    }
  }

  changePage(start: number, limit: number) {
    this.search.start = start;
    this.search.limit = limit;
    this.loadProducts(this.search);
  }

  getPageIndex(): number {
    return (this.search && this.search.start / this.search.limit) || 0;
  }

  getPageSize(): number {
    return (this.search && this.search.limit) || 0;
  }
}

